// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconWarningCircle = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='#D74E3A'
            fillRule='evenodd'
            d='M8 1.335A6.666 6.666 0 0 1 14.667 8 6.666 6.666 0 0 1 8 14.668a6.666 6.666 0 0 1-6.667-6.667A6.666 6.666 0 0 1 8 1.335M7.374 5.31c0-.356.28-.643.625-.643.347 0 .626.287.626.643v3a.633.633 0 0 1-.626.643.633.633 0 0 1-.625-.643zM8 9.81c.461 0 .834.383.834.857a.845.845 0 0 1-.834.857.845.845 0 0 1-.833-.857c0-.474.373-.857.833-.857'
            clipRule='evenodd'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconWarningCircle)
const Memo = memo(ForwardRef)
export default Memo
